"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const Row = ({
  children,
  danger,
  info,
  muted,
  notice,
  success,
  warning,
  border,
  ...props
}) => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("tr", {
    ...props,
    css: theme => [border && _styles.styles.row_border(theme), danger && _styles.styles.row_danger(theme), info && _styles.styles.row_info(theme), muted && _styles.styles.row_muted(theme), notice && _styles.styles.row_notice(theme), success && _styles.styles.row_success(theme), warning && _styles.styles.row_warning(theme)],
    children: children
  });
};
var _default = exports.default = Row;